/* import __COLOCATED_TEMPLATE__ from './time-trend-picker-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Args: {
    item: {
      text: string;
    };
    componentAttrs: {
      icon: InterfaceIconName;
      description: string;
    };
  };
}

const TimeTrendPickerItem = templateOnlyComponent<Signature>();
export default TimeTrendPickerItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    TimeTrendPickerItem: typeof TimeTrendPickerItem;
    'time-trend-picker-item': typeof TimeTrendPickerItem;
  }
}
